import {observer} from 'mobx-react';
import {EmptyFormState} from 'shared/components/forms/question/state';
import {withState} from 'shared/core';

const EmptyForm = observer(() => {
  return null;
});


export default withState(EmptyForm, EmptyFormState);
